import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

const ChatReceive = props => {
  return (
    <Container className="chat-receive" id={props.message.id}>
      <Row className="d-flex justify-content-center" style={{ color: 'grey', fontSize: '.7rem' }}>
        {props.date}
      </Row>
      <Row className="d-flex justify-content-start">
        <div className="chat-box">
          <Container>
            <Row>
              <Col
                className="d-flex align-items-center"
                style={{ whiteSpace: 'break-spaces', paddingLeft: '10px' }}
              >
                <span>
                  {props.message.message}
                  {props.message.editedAt && <span className="chat-edited-marker">(modifié)</span>}
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </Row>
    </Container>
  );
};

export default ChatReceive;
